document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-review-metaobject').forEach(widget => {
    const track = widget.querySelector('.product-review-metaobject__track');
    const dots  = widget.querySelectorAll('.product-review-metaobject__dot');

    if (!track || !dots.length) return;

    // ── Auto-play ──────────────────────────────────────────────
    const INTERVAL = 4000;
    let timer;

    function getActiveIndex() {
      const cardWidth = track.firstElementChild?.offsetWidth || track.offsetWidth;
      return Math.round(track.scrollLeft / cardWidth);
    }

    function goTo(index) {
      const cardWidth = track.firstElementChild?.offsetWidth || track.offsetWidth;
      track.scrollTo({ left: cardWidth * index, behavior: 'smooth' });
    }

    function setActiveDot(index) {
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
    }

    function next() {
      const total = dots.length;
      goTo((getActiveIndex() + 1) % total);
    }

    function startAuto() {
      clearInterval(timer);
      timer = setInterval(next, INTERVAL);
    }

    // ── Sync dots on scroll ────────────────────────────────────
    let scrollRaf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(scrollRaf);
      scrollRaf = requestAnimationFrame(() => {
        setActiveDot(getActiveIndex());
      });
    }, { passive: true });

    // ── Dot click ─────────────────────────────────────────────
    dots.forEach((dot, i) => {
      dot.addEventListener('click', e => {
        e.preventDefault();
        goTo(i);
        startAuto(); // reset timer on manual interaction
      });
    });

    // ── Pause on hover / touch ─────────────────────────────────
    widget.addEventListener('mouseenter', () => clearInterval(timer));
    widget.addEventListener('mouseleave', startAuto);
    widget.addEventListener('touchstart',  () => clearInterval(timer), { passive: true });
    widget.addEventListener('touchend',    startAuto, { passive: true });

    // ── Kick off ───────────────────────────────────────────────
    startAuto();
  });
});